import React from "react";
import Image10 from "../../../assets/images/simulation/phy/12/01/MBridge.jpeg";
import Image11 from "../../../assets/images/simulation/phy/12/01/MeterBridgePro1.png";
import Image12 from "../../../assets/images/simulation/phy/12/01/MeterBridgePro2.png";

const ProcedureTemplate = () => {
  return (
    <div className="flex flex-wrap text-lg font-body text-gray-900 leading-relaxed tracking-wide px-4 py-5">
      {/* Main Content */}
      <div className="mb-1">
        <h2 className="font-semibold"> ডায়াগ্রাম: </h2>
        <img src={Image10} alt="simulation-theory" className="py-1" />
      </div>

      <div className="min-w-full mb-2">
        <h2 className="font-semibold mb-1"> প্রয়োজনীয় যন্ত্রপাতি: </h2>
        <ul className="list-inside leading-loose list-disc">
          <li>মিটার ব্রিজ (স্লাইড তারের সেতু)</li>
          <li>লেক্লেঞ্চ সেল বা ব্যাটারি নির্মূলকারী</li>
          <li>গ্যালভানোমিটার</li>
          <li>রোধের বাক্স</li>
          <li>জকি</li>
          <li>ওয়ান ওয়ে কী</li>
          <li>একটি রোধের তারের</li>
          <li>স্ক্রু গজ</li>
          <li>মিটার স্কেল</li>
          <li>সংযোগ তারের</li>
        </ul>
      </div>
      {/* Procedure 1 */}
      <div className="mb-2 mt-4">
        <h2 className="font-semibold mb-1"> বাস্তব ল্যাব এর কার্যধারা </h2>
        <ul className="list-inside leading-loose list-disc">
          <li>
            একটি টেবিলে প্রয়োজনীয় উপকরণগুলি সজ্জিত করলাম এবং সংযোগ ডায়াগ্রাম
            অনুযায়ী সংযোগগুলি তৈরি করলাম।
          </li>
          <li>
            আমি একটি টেবিলের উপর প্রয়োজনীয় উপকরণগুলি সাজিয়েছি এবং সংযোগ
            ডায়াগ্রাম অনুসারে সংযোগগুলি তৈরি করেছি।
          </li>
          <li>
            রোধের বাক্স থেকে কিছু রোধ বের করে সার্কিটের কিছু রোধের পরিচয় করিয়ে
            দেই।
          </li>
          <li>
            কী টি প্লাগ করি। জকিটিকে প্রথমে শেষের সাথে যোগাযোগ করলাম এবং তারপরে
            C এর সাহায্যে গ্যালভানোমিটারের অপসারণটি নোট করি।
          </li>
          <li>
            যদি গ্যালভানোমিটার বিপরীত দিকটিতে প্রতিফলিত হয় তবে সংযোগগুলি সঠিক
            হয় এবং নাল পয়েন্টটি A এবং C এর মধ্যে থাকে।
          </li>
          <li>
            যদি তা না হয়, রোধ বাক্সে রোধের পরিবর্তন করুন এবং প্রক্রিয়াটি
            পুনরাবৃত্তি করুন যাতে নাল পয়েন্টটি A এবং C এর মধ্যে কোথাও থাকে।
          </li>
          <li>একটি রোধের তারের</li>
          <li>
            যদি গ্যালভানোমিটার একক দিকে ঘুরতে থাকে তবে সংযোগ পরীক্ষা করে দেখি।
          </li>
          <li>
            এখন, জকিটিকে ধীরে ধীরে তার থেকে শুরু করে তার থেকে শুরু করে একটি (ধরি
            A) এবং গ্যালভানোমিটারের প্রতিবিম্বটি নোট করি। ব্যালেন্সিং পয়েন্ট
            পৌঁছানো পর্যন্ত প্রক্রিয়া চালিয়ে যাই।
          </li>
          <li>
            ব্যালেন্সিং পয়েন্ট হল সেই বিন্দুতে যেখানে গ্যালভানোমিটার শূন্যের
            বর্ধন দেখি । এখন, শেষের দিক থেকে জকিটির অবস্থানটি নোট করে মিটার
            স্কেলটি ব্যবহার করে ভারসাম্য দৈর্ঘ্যের (l) হিসাবে নেই।
          </li>
          <li>
            আর এর বিভিন্ন মানের জন্য প্রক্রিয়াটি পুনরাবৃত্তি করি ভারসাম্যের
            দৈর্ঘ্য প্রতিবার পরিমাপ করি।
          </li>
          <li>
            এখন, ফাঁকা AB এবং CD রোধের তারের এবং রোধের বাক্সের অবস্থানটি বিনিময়
            করি।
          </li>
          <li>
            R এর সমান মানগুলির জন্য ভারসাম্য দৈর্ঘ্যের সন্ধান করতে উপরের
            পদক্ষেপগুলি পুনরাবৃত্তি করি।
          </li>
          <li>
            আমরা সূত্র ব্যবহার করে রোধ তারের অজানারোধ এর মান গণনা করতে পারি,
          </li>
          <img src={Image11} alt="simulation-theory" className="py-1" />
          <li>
            স্ক্রু গেজ ব্যবহার করে প্রদত্ত রোধ তারের ব্যাস পরিমাপ করি । সুতরাং,
            এর ব্যাসার্ধ (R) পাওয়া যাবে।
          </li>
          <li>মিটার স্কেল ব্যবহার করে তারের দৈর্ঘ্য (L) পরিমাপ করি ।</li>
          <li>
            পরিমাপ করা মানগুলি থেকে, প্রদত্ত রোধের তারের নির্দিষ্ট রোধের (রোধ এর
            ক্ষমতা) টিকে ব্যবহার করে গণনা করা যেতে পারে,
          </li>
          <img src={Image12} alt="simulation-theory" className="py-1" />
        </ul>
      </div>
      {/* Procedure 2 */}
      <div className="mb-12 mt-8">
        <h2 className="font-semibold mb-1">
          সিমুলেটর কার্যধারা (অনলাইন ল্যাব এর মাধ্যমে সম্পাদিত):
        </h2>
        <ul className="list-inside leading-loose list-disc">
          <li>
            আপনার সিমুলেটরটিতে পাশের মেনুতে একটি টেবিল, ব্যাটারি, রোধেরের বাক্স
            এবং তারগুলিতে রাখা মিটার ব্রিজ থাকবে।
          </li>
          <li>
            পাশের বার মেনুতে প্রদর্শিত ব্যাটারি এবং রোধেরের বাক্সটিতে ক্লিক করে
            সেগুলি মিটার ব্রিজের নিকটে রাখুন।
          </li>
          <li>তারের একটি মিটার ব্রিজের ডান ফাঁক করে টানুন।</li>
          <li>এখন, "পরীক্ষা শুরু করুন" বোতামটি সক্ষম হবে।</li>
          <li>
            এখন আপনি কেবল বাক্সে ক্লিক করে এবং তারপরে পপ-উইন্ডো থেকে "রোধেরের
            নির্বাচন করুন" নির্বাচন করে রোধেরের বাক্সটি দিয়ে রোধেরের বাক্স থেকে
            আপনার পছন্দসই রোধের নির্বাচন করতে পারেন। এখন পপ-উইন্ডোটি বন্ধ করুন।
          </li>
          <li>সক্ষম বোতামটিতে ক্লিক করুন এবং "কী সন্নিবেশ করুন"।</li>
          <li>
            এখন আপনি জকিটিকে একটি বাম প্রান্ত থেকে ডান দিকে নিয়ে যেতে পারেন হয়
            আপনার মাউস দিয়ে জকিকে সরানো বা স্লাইডার, "জকি পজিশন" সরিয়ে দিয়ে।
          </li>
          <li>
            যএকই সাথে গ্যালভানোমিটারের রিডিংগুলি পরীক্ষা করুন, একবার সুই শূন্য
            পঠন পৌঁছানোর পরে, জকি সরিয়ে নেওয়া বন্ধ করুন এবং বাম দিকে
            ভারসাম্যপূর্ণ অবস্থান থেকে তারের দৈর্ঘ্যটি নোট করুন, AB বলুন যা L
            সেমি হয়।
          </li>
          <li>
            জকিটিকে ডান প্রান্ত থেকে বাম দিকে সরানোর মাধ্যমে একই পুনরাবৃত্তি
            করুন এবং ডানদিকে ভারসাম্যপূর্ণ অবস্থান থেকে তারের দৈর্ঘ্যটি নোট
            করুন, এটি BC হিসাবে নেওয়া যাক (100-l) সেমি।
          </li>
          <li>
            দ্বিতীয় তারের সাথে একই পদ্ধতিটি পুনরাবৃত্তি করুন এবং দৈর্ঘ্যগুলি
            নোট করুন।
          </li>
          <li>
            প্রতিটি তারের জন্য তিনটি রিডিং নিন এবং তার গড় পঠ / রোধের গণনা করুন।
          </li>
          <li>
            আপনি সূত্র ব্যবহার করে রোধ তারের অজানারোধ এর মান গণনা করতে পারেন,
          </li>
          <img src={Image11} alt="simulation-theory" className="py-1" />
          <li>
            যদি L এর দৈর্ঘ্য হয় এবং আর তারের ব্যাসার্ধ হয় তবে প্রদত্ত রোধের
            তারের নির্দিষ্ট রোধের (রোধ ক্ষমতা) সম্পর্কটি ব্যবহার করে গণনা করা
            যেতে পারে,
          </li>

          <li>
            পরিমাপ করা মানগুলি থেকে, প্রদত্ত রোধের তারের নির্দিষ্ট রোধের (রোধ এর
            ক্ষমতা) টিকে ব্যবহার করে গণনা করা যেতে পারে,
          </li>
          <img src={Image12} alt="simulation-theory" className="py-1" />
        </ul>
      </div>
    </div>
  );
};

export default ProcedureTemplate;
